import { StyledLoader } from './styles';

type LoaderProps = {
  size?: number;
  borderWidth?: number;
};

export const Loader: React.FC<LoaderProps> = ({ size = 24, borderWidth = 2.5 }: LoaderProps) => {
  return <StyledLoader size={size} borderWidth={borderWidth} />;
};
